export default "__VITE_ASSET__BtoloAMm__"